import React, { Component } from 'react';

interface MainProps {
  className: any
  children: React.ReactNode
}
export default class Main extends Component<MainProps> {
  render() {
    return (
      <main className={this.props.className}>
        {this.props.children}
      </main>
    );
  }
}
